import {computed} from 'mobx';

export default class IconModel {
    constructor(store, id, type, text, image, color = '#BADA55', reactionContainer, routing = false) {
        this.store = store; // AppStore;
        this.id = id;
        this.text = text;
        this.image = image;
        this.color = color;
        this.reactionContainer = reactionContainer;
        this.routing = routing;
        this.type = type;
    }

    @computed get disabled() {
        //CODE-REVIEW don't need === true for bools
        return (this.store.pendingState.savePopup && this.store.pendingState.element && this.store.pendingState.element.icon !== this.id)

    };

    static fromJS(store, object, type) {
        return new IconModel(store, object.id, type, object.text, object.image, object.color, object.reactionContainer, object.routing);
    }
}


// WEBPACK FOOTER //
// ./src/models/IconModel.js